export const ExpandoSvg: string =
`<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="13" height="13">
  <style>
    path{fill:#666}
    .active path{fill:#333}
  </style>
  <path d="M2.8,9.2l3.7-3.6l3.7,3.6c0.2,0.2,0.6,0.2,0.8,0s0.2-0.7,0-0.8L6.5,3.8L2,8.4	C1.8,8.6,1.8,8.9,2,9.2C2.2,9.4,2.6,9.4,2.8,9.2z"/>
</svg>`;
